<template>
	<div>
		<div v-show="this.type == 'stop'" class="container">
			<b-row>
				<b-col><label>{{ $t('map.tooltip.number') }}</label></b-col>
				<b-col>{{ stopNumber }}</b-col>
			</b-row>
			<b-row>
				<b-col><label>{{ $t('map.tooltip.name') }}</label></b-col>
				<b-col>{{ stopName }}</b-col>
			</b-row>
			<b-row>
				<b-col><label>{{ $t('map.tooltip.type') }}</label></b-col>
				<b-col>{{ stopType }}{{ stopOnDemand }}</b-col>
			</b-row>
		</div>
		<div v-show="this.type == 'device'" class="container">
			<b-row>
				<b-col><label>{{ $t('map.tooltip.name') }}</label></b-col>
				<b-col>{{ deviceName }}</b-col>
			</b-row>
		</div>

		<div v-show="this.type == 'vehicle'" class="container">
			<b-row>
				<b-col><label>{{ $t('map.tooltip.vehicle') }}</label></b-col>
				<b-col>{{ vehicleLabel }}</b-col>
			</b-row>
			<b-row>
				<b-col><label>{{ $t('map.tooltip.type') }}</label></b-col>
				<b-col>{{ vehicleType }}</b-col>
			</b-row>
			<b-row v-if="$UiConfig('/data/vehicle/showObu', true)">
				<b-col><label>{{ $t('map.tooltip.computer') }}</label></b-col>
				<b-col>{{ vehicleComputerType }}</b-col>
			</b-row>
			<b-row>
				<b-col><label>{{ $t('map.tooltip.time') }}</label></b-col>
				<b-col :class="timeLimitExceeded && 'lastseen-alert'">{{ lastSeenTime }}</b-col>
			</b-row>

			<template v-if="vehicleBlockSequence">
				<!-- <hr> -->
				<b-row><b-col><label>{{ $t('map.tooltip.block_sequence') }}</label></b-col>
					<b-col>{{ vehicleBlockSequence }}</b-col>
				</b-row>
				<b-row>
					<b-col><label>{{ $t('map.tooltip.line') }}</label></b-col>
					<b-col>{{ vehicleLineLabel }}</b-col>
				</b-row>
				<b-row>
					<b-col><label>{{ $t('map.tooltip.destination') }}</label></b-col>
					<b-col>{{ vehicleDestination }}</b-col>
				</b-row>
				<b-row>
					<b-col><label>{{ $t('map.tooltip.schedule') }}</label></b-col>
					<b-col>{{ vehicleDeviation }}</b-col>
				</b-row>
				<b-row v-if="$UiConfig('/data/departure/showCourse', false)">
                    <b-col><label>{{ $t('map.tooltip.course') }}</label></b-col>
                    <b-col>{{ vehicleTripShortName }}</b-col>
				</b-row>
			</template>
		</div>

		<div v-show="this.type === 'scheduledRoute'" class="container">
			{{ $t('map.tooltip.scheduled_route') }}
		</div>

		<div v-show="this.type === 'gpsRoute'" class="container">
			{{ $t('map.tooltip.gps_route') }}
		</div>

		<div v-show="this.type == 'unknown'" class="container">
			{{ $t('item.no_results') }}
		</div>
	</div>
</template>

<script>
import olf from '@/components/Map/OpenLayersFunctions.js'
import timetable from '@/store/timetable/timetable'
import moment from 'moment'
import realtimeLogic from '@/services/realtimeLogic'

export default {
	name: 'MapTooltip',
	data: function () {
		return {
			type: '',
			routeData: null,
		}
	},
	props: {
		item: null,
	},
	beforeCreate() {
		if (!this.$store.state.timetable) {
			this.$store.registerModule('timetable', timetable)
		}
	},
	beforeDestroy() {
		this.routeData = null
	},
	mounted() {
		this.routeData = null
		this.detectType()
	},
	methods: {
		detectType: function () {
			if (this.item) {
				if (this.item.getKeys().includes('stopData')) {
					this.type = 'stop'
				} else if (this.item.getKeys().includes('deviceId')) {
					this.type = 'device'
				} else if (this.item.getKeys().includes('vehicleData')) {
					this.type = 'vehicle'
					this.routeData = null
					if (this.item.values_.routeId) {
						this.$store
							.dispatch('timetable/getRouteStops', this.item.values_.routeId)
							.then(
								(data) => {
									try {
										this.routeData = data.data
									} catch (err) {
										this.routeData = null
									}
								},
								(/*err*/) => {
									/*console.log(err)*/
								}
							)
					}
				} else if (this.item.getKeys().includes('label')) {
					const label = this.item.get('label')
					this.type = label
				}
			} else {
				this.type = 'unknown'
			}
		},
	},
	computed: {
		stopNumber: function () {
			try {
				return this.item.get('stopData').sms
			} catch (err) {
				return ''
			}
		},
		stopName: function () {
			try {
				if (
					this.item.get('stopData').nimi == null ||
					this.item.get('stopData').nimi.length < 1
				) {
					return this.item.get('stopData').tunnus
				} else return this.item.get('stopData').nimi
			} catch (err) {
				return ''
			}
		},
		stopType: function () {
			try {
				const stopFeatures = this.item.get('stopData').stopFeatures
				const type =
					stopFeatures && stopFeatures.LINE_TYPE ? stopFeatures.LINE_TYPE : 'x'
				return this.$t('map.stop_type.' + type)
			} catch (err) {
				return ''
			}
			/*
      try{
        if(this.item.get('stopData').stopFeatures.LINE_TYPE == 0){
          return this.$t('map.stop_type.tram')
        }else{
          return this.$t('map.stop_type.bus')
        }
      } catch(err){
        return "";
      }
      */
		},
		stopOnDemand: function () {
			try {
				if (this.item.get('stopData').stopFeatures.ON_DEMAND == 'true') {
					return ' - ' + this.$t('map.stop_type.on_demand')
				} else {
					return ''
				}
			} catch (err) {
				return ''
			}
		},
		deviceName: function () {
			try {
				if (this.item.getKeys().includes('infopointData')) {
					return this.item.get('infopointData').name
				} else {
					return this.item.get('deviceData').name
				}
			} catch (err) {
				return ''
			}
		},
		vehicleLabel: function () {
			try {
				return this.item.get('vehicleData').vehicleLabel
			} catch (err) {
				return ''
			}
		},
		vehicleType: function () {
			try {
				return this.item.get('vehicleData').features.VEHICLE_TYPE
			} catch (err) {
				return ''
			}
		},
		vehicleBlockSequence: function () {
			try {
				return this.item.values_.blockSequence
			} catch (err) {
				return ''
			}
		},
		vehicleLineLabel: function() {
			try {
				return this.item.values_.lineLabel
			} catch (err) {
				return ''
			}
		},
		vehicleDestination: function() {
			try {
				if (this.routeData.destination) {
					return this.routeData.destination
				} else {
					return this.routeData.routestops[this.routeData.routestops.length - 1].nimi
				}
			} catch (err) {
				return ''
			}
		},
		vehicleDeviation: function() {
			try {
				return realtimeLogic.getDeviationInRightFormat(
					this.item.values_.lastSeenTime,
					this.item.values_.deviation,
					this.vehicleBlockSequence
				)
			} catch (err) {
				return ''
			}
		},
        vehicleTripShortName: function() {
			try {
				return this.item.values_.tripShortName;
			} catch (err) {
				return '';
			}
		},
		vehicleComputerType() {
			try {
				return this.item.get('vehicleData').features.VEHICLE_COMPUTER_TYPE
			} catch (err) {
				return ''
			}
		},
		lastSeenTime() {
			let time = ''
			try {
				//time = new moment(this.item.values_.lastSeenTime, 'YYYY-MM-DD[T]HH:mm:ssZZ').format('DD.MM.YYYY HH:mm:ss');
				time = new moment(
					this.item.values_.gpsTimestamp,
					'YYYY-MM-DD[T]HH:mm:ssZZ'
				).format('DD.MM.YYYY HH:mm:ss')
				if (time.startsWith('Invalid')) time = ''
			} catch (err) {
				time = ''
			}
			return time
		},
		timeLimitExceeded() {
			//return this.item ? olf.timeLimitExceeded(this.item.values_.lastSeenTime) : false;
			return this.item
				? olf.timeLimitExceeded(this.item.values_.gpsTimestamp)
				: false
		},
	},
	watch: {
		item: function () {
			this.detectType()
		},
	},
}
</script>

<style scoped lang="scss">
.container {
	font-size: small;
	text-shadow: none;
	display: table;
	padding: 0;

	.row {
		display: table-row;
		padding: 0;
	}

	.col {
		display: table-cell;
		width: fit-content;
		text-align: left;
		padding: 0;

		label {
			padding: 0 10px 0 0;
			color: #9a9a9a;
		}
	}
}

// Toltip-tip shadow
.container::before {
	position: absolute;
	display: inline-block;
	border-right: 10px solid transparent;
	border-top: 11px solid #464646d7;
	border-left: 10px solid transparent;
	bottom: -12px;
	right: calc(50% - 12px);
	content: '';
}

// Toltip-tip
.container::after {
	position: absolute;
	display: inline-block;
	border-right: 10px solid transparent;
	border-top: 11px solid #ffffff;
	border-left: 10px solid transparent;
	bottom: -10px;
	right: calc(50% - 10px);
	content: '';
}
</style>
